export default "__VITE_ASSET__50022280__"